var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-range-picker',{attrs:{"maxDate":_vm.maxDate,"minDate":_vm.minDate,"locale-data":_vm.locale_data,"opens":"right","date-format":_vm.dateFormat},on:{"update":(selectedOpt) => _vm.updateDate(selectedOpt)},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})
}
var staticRenderFns = []

export { render, staticRenderFns }